import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import DefaultData from '../../CompanyData/DefaultData';
import { FaQuestionCircle } from 'react-icons/fa';
import HelpContactPanel from './HelpContactPanel';
export default function PublicHeader() {
  const [showHelpPanel, setShowHelpPanel] = useState(false);

  const navLinkStyle = {
    textDecoration: 'none',
    color: DefaultData.THEMECOLOR2,
    margin: '0 1rem',
    fontWeight: '500',
    fontSize: '0.95rem',
    padding: '0.4rem 0',
    transition: 'all 0.2s ease',
    whiteSpace: 'nowrap'
  };

  const activeNavLinkStyle = {
    ...navLinkStyle,
    color: '#000000',
    borderBottom: `2px solid ${DefaultData.THEMECOLOR1}`
  };

  return (
    <header className="bg-white shadow-sm sticky-top">
      <div className="container-fluid px-4 py-2">

        <div className="d-flex justify-content-between align-items-center">

          {/* Logo */}
          <Link to="/" className="text-decoration-none d-flex align-items-center">
            <img
              src="/assets/images/Zotrai.png"
              alt={`${DefaultData.DEFAULTBRANDNAME} Logo`}
              style={{ height: '35px' }}
            loading="lazy" />
          </Link>

          {/* Navigation */}
          <nav className="d-none d-lg-flex align-items-center justify-content-center flex-grow-1">
            <NavLink to="/about" style={({ isActive }) => isActive ? activeNavLinkStyle : navLinkStyle}>
              About
            </NavLink>

            <NavLink to="/supplierregister" style={({ isActive }) => isActive ? activeNavLinkStyle : navLinkStyle}>
              API Suppliers
            </NavLink>

            <NavLink to="/dmcregister" style={({ isActive }) => isActive ? activeNavLinkStyle : navLinkStyle}>
              DMCs
            </NavLink>
            <NavLink
              to="https://calendly.com/zotrai/zotrai-demo"
              style={navLinkStyle}
              target="_blank"
              rel="noopener noreferrer"
            >
              Book Demo
            </NavLink>
            <NavLink to="/travel-websites" style={({ isActive }) => isActive ? activeNavLinkStyle : navLinkStyle}>
  Websites
</NavLink>
          </nav>

          {/* Right Section */}
          <div className="d-flex align-items-center gap-3">

  {/* Help */}
  <button
    type="button"
    onClick={() => setShowHelpPanel(true)}
    className="d-flex align-items-center text-decoration-none border-0 bg-transparent p-0"
    style={{
      color: DefaultData.THEMECOLOR2,
      fontWeight: '500',
      gap: '6px'
    }}
    title="Help & Contact"
  >
    <FaQuestionCircle style={{ fontSize: '16px' }} />
    <span className="d-none d-md-inline">Help</span>
  </button>

  {/* CTA */}
  <Link 
    to="/register" 
    className="btn px-4"
    style={{ 
      backgroundColor: DefaultData.THEMECOLOR1, 
      color: DefaultData.THEMECOLOR3,
      borderRadius: '6px',
      fontSize: '0.9rem'
    }}
  >
    Agent Registration
  </Link>

</div>
        </div>

      </div>

      <HelpContactPanel show={showHelpPanel} onHide={() => setShowHelpPanel(false)} />
    </header>
  );
}